import React from 'react';
import { useSocialProof } from '../hooks/useSocialProof';
import { CheckCircle } from 'lucide-react';
export function SocialProofPopup() {
  const {
    visible,
    buyer,
    setVisible
  } = useSocialProof();
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-slide-up" data-id="element-131">
      <div className="bg-white rounded-lg shadow-xl border border-gray-100 p-4 flex items-center gap-4 max-w-xs relative overflow-hidden" data-id="element-132">
        <button onClick={() => setVisible(false)} className="absolute top-1 right-1 text-gray-400 hover:text-gray-600" data-id="element-133">
          ×
        </button>
        <div className="bg-green-100 p-2 rounded-full" data-id="element-134">
          <CheckCircle className="w-6 h-6 text-green-600" data-id="element-135" />
        </div>
        <div data-id="element-136">
          <p className="text-sm font-bold text-gray-900" data-id="element-137">
            {buyer.name} de {buyer.city}
          </p>
          <p className="text-xs text-gray-600" data-id="element-138">acaba de comprar el MegaPack</p>
          <p className="text-xs text-gray-400 mt-1" data-id="element-139">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}